import {
  QUICK_ACCESS_DEFAULT_KEYS,
  QUICK_ACCESS_MAX_RECENTS,
  QUICK_ACCESS_STORAGE_PREFIX,
  QuickAccessStorageBucket,
} from '~/constants/quickAccess';

const buildStorageKey = (userId: string, bucket: QuickAccessStorageBucket) =>
  `${QUICK_ACCESS_STORAGE_PREFIX}:${bucket}:${userId}`;

const readKeys = (userId: string, bucket: QuickAccessStorageBucket): string[] => {
  if (!userId) return [];

  try {
    const raw = window.localStorage.getItem(buildStorageKey(userId, bucket));
    if (!raw) return [];

    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];

    return parsed.filter((item): item is string => typeof item === 'string');
  } catch {
    return [];
  }
};

const writeKeys = (userId: string, bucket: QuickAccessStorageBucket, keys: string[]): void => {
  if (!userId) return;

  try {
    window.localStorage.setItem(buildStorageKey(userId, bucket), JSON.stringify(keys));
  } catch {
    // em falha de persistência, não quebra a navegação
  }
};

export const getDefaultShortcuts = (): string[] => [...QUICK_ACCESS_DEFAULT_KEYS];

export const getUserPins = (userId: string): string[] =>
  readKeys(userId, QuickAccessStorageBucket.Pins);

export const setUserPins = (userId: string, keys: string[]): void =>
  writeKeys(userId, QuickAccessStorageBucket.Pins, keys);

export const getRecents = (userId: string): string[] =>
  readKeys(userId, QuickAccessStorageBucket.Recents);

export const registerAccess = (userId: string, menuKey: string): string[] => {
  if (!userId || !menuKey) return [];

  const next = [menuKey, ...getRecents(userId).filter(key => key !== menuKey)].slice(
    0,
    QUICK_ACCESS_MAX_RECENTS,
  );

  writeKeys(userId, QuickAccessStorageBucket.Recents, next);
  return next;
};
